import {checkExists} from 'external/dev_april_corgi+/js/common/asserts';

import {DataConstraints, PipeId} from '../execution/graph';
import {PTransformer, PipeContext, Source} from '../execution/pipes';
import {ArrayValue, PlatedMaterialValue} from '../types/data';

export class ElementSelectingTransformer extends PTransformer<
  ArrayValue<ArrayValue<PlatedMaterialValue>>,
  ArrayValue<PlatedMaterialValue>
> {
  constructor(
    id: PipeId,
    private readonly array: Source<ArrayValue<ArrayValue<PlatedMaterialValue>>>,
    private readonly index: number,
  ) {
    super(id, [array]);
  }

  async collate(context: PipeContext): Promise<void> {
    const array = checkExists(this.values.get(this.array));
    const value = array.value?.elements[this.index];
    const constraints = await this.gatherConstraints(value, context);
    const upstreamConstraints = {array: [] as DataConstraints[]};
    for (let i = 0; i < (array.value?.elements.length ?? 0); ++i) {
      if (i === this.index) {
        upstreamConstraints.array.push(constraints);
      } else {
        upstreamConstraints.array.push({
          array: Array(array.value?.elements[i].elements.length).fill({
            volume: {numberNl: 0},
          }),
        });
      }
    }
    await array.resolve(upstreamConstraints);
  }
}
